export default __webpack_public_path__ + "static/media/jellyfish.97376acb.png";